import codes from '../../../../shared/projection_validation_codes.json';

export const VALIDATION_CODES = codes as {
    driven_null: 'driven_null';
    missing_driver: 'missing_driver';
    open_store_undriven: 'open_store_undriven';
    pct_of_line_cycle: 'pct_of_line_cycle';
    bs_identity: 'bs_identity';
    one_time_invalid: 'one_time_invalid';
    duplicate_name: 'duplicate_name';
    expired: 'expired';
    outlier: 'outlier';
    new_negative: 'new_negative';
    cash_negative: 'cash_negative';
    days_over_365: 'days_over_365';
    mom_yoy_extreme: 'mom_yoy_extreme';
    days_open_overflow: 'days_open_overflow';
    zero_denominator: 'zero_denominator';
    incomplete_ignore_group: 'incomplete_ignore_group';
    policy_schedule_missing: 'policy_schedule_missing';
    policy_schedule_stale: 'policy_schedule_stale';
    policy_schedule_invalid: 'policy_schedule_invalid';
    policy_one_time_invalid: 'policy_one_time_invalid';
    policy_one_time_spent: 'policy_one_time_spent';
    policy_negative: 'policy_negative';
    policy_anchor_invalid: 'policy_anchor_invalid';
    policy_view_invalid: 'policy_view_invalid';
    policy_floor_breach: 'policy_floor_breach';
    policy_yield_unavailable: 'policy_yield_unavailable';
    policy_yield_old: 'policy_yield_old';
    policy_above_solver: 'policy_above_solver';
    policy_floor_unsized: 'policy_floor_unsized';
    policy_outputs_mismatch: 'policy_outputs_mismatch';
    pay_period_anchor_stale: 'pay_period_anchor_stale';
    labor_buildup_inputs: 'labor_buildup_inputs';
    labor_buildup_derived: 'labor_buildup_derived';
    recipe_mismatch: 'recipe_mismatch';
    consolidated_only_not_in_total: 'consolidated_only_not_in_total';
    cf_not_tied: 'cf_not_tied';
    cf_other_equity_movement: 'cf_other_equity_movement';
};

export type ValidationCode = (typeof VALIDATION_CODES)[keyof typeof VALIDATION_CODES];

export const DEFAULT_THRESHOLDS = {
    outlier_multiple: 5,
    outlier_abs: 2_500_000,
    mom_pct_max: 0.5,
    yoy_pct_max: 3.0,
    days_max: 365,
};
